<template>
  <span>
    <span v-show="item.edited == '1'">
      <p v-if="item.output == 'list'" class="mt-2 editForm">
         - {{selectedText}}<br />
         <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </p>
      <span v-if="item.output == 'line'" class="editForm">
        {{selectedText}}
        <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </span>
    </span>
    <b-card no-body v-show="item.edited == '0'" class="mt-2">      
      <b-card-body>
        <b-form-select v-model="currentSelected" :options="options" :name="`dropdopwn-select-${item.id}`"></b-form-select>
      </b-card-body>
      <b-card-footer>
        <b-button class="float-right mt-2 btn-fill" :disabled="isDisabled" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </span>
</template>
<script>
export default {
  props: ["value", "id","templateId"],
  data() {
    return {
      item: this.value,
      currentSelected: null,
      selectedText: '',
      options: [
        { value: null, text: this.$t("PLEASE_SELECT") }
      ],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      if(this.currentSelected == null)
      {
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      }else{
        let self = this;
        this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
          templateId: this.templateId,
          answers:  [{
            key: this.item.id,
            value: this.currentSelected
          }]
        })
        .then(function() {
          for (let ix = 0; ix < self.item.items.length; ix++) {
            let object = self.item.items[ix];
            if(self.currentSelected == object.value)
            {
              self.selectedText = object.title;
              self.item.edited = "1";
            }
          }    
          self.$emit("input",self.item);
        })
        .catch(function() {
          self.item.edited = "0";
          self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
        });    
      }    
    },
    removeEdit: function() {   
      this.item.edited = "0";
    }
  },
  computed: {
    isDisabled() {
      if (this.currentSelected !== null) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {    
    for (let ix = 0; ix < this.item.items.length; ix++) {
      let object = this.item.items[ix];
      this.options.push(
          {
            value: object.value,
            text: object.title
          }
      );
      if(this.item.edited == '1')
      {
        this.currentSelected = this.item.value;
        if(this.item.value == object.value)
        {
          this.selectedText = object.title;
        }     
      }      
    }
  }
};
</script>
<style>
</style>